export enum RenderedObjectTypeEnum {
	// This drives whether the mesh that is generated relates to an entity or something else
	ENTITY = "ENTITY",
	FLOOR = "FLOOR",
	FACE = "FACE"
}
